import { useQuery } from '@tanstack/react-query';

import type { CmChecklist } from '@luxuryescapes/contract-svc-offer';

import OffersService from '~/services/OffersService';

export const cmChecklistPolicyBibleQueryKey = ['cm-checklist-policy-bible'] as const;

export function useGetCMChecklistPolicyBible({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery<CmChecklist.PolicyBible>({
    queryKey: cmChecklistPolicyBibleQueryKey,
    queryFn: async ({ signal }) => {
      const response = await OffersService.getCMChecklistPolicyBible({ signal });
      return response.result;
    },
    enabled,
    // The table only changes when svc-offer deploys.
    staleTime: Infinity,
  });
}
